import type { SettingsResponse } from "@go-novus/admin-api";

import type { ProactiveRuleDraft } from "./proactive-rules";

/**
 * 拾取入口只发给「已保存的元素可见规则」：令牌绑定的是已保存配置里的那条，
 * 新规则和任何未保存改动都得先 Save changes（GON-62）。
 */
export type PickEligibility = "ready" | "save_first" | "unavailable";

export function readPickEligibility(
  rule: ProactiveRuleDraft,
  saved: SettingsResponse,
  draftDirty: boolean,
): PickEligibility {
  if (rule.trigger !== "element_visible") return "unavailable";
  const savedRule = saved.proactiveRules.find((item) => item.id === rule.id);
  if (draftDirty || savedRule?.trigger !== "element_visible") {
    return "save_first";
  }
  return "ready";
}

/**
 * 拾取返回后对比前后两份已保存配置，判断绑定规则上的写回结果。
 * `gone` 覆盖规则被删和触发类型被改两种失效；`unchanged` 包括配置里
 * 别处动了而目标选择器没变。
 */
export type PickOutcome =
  | { kind: "applied"; selector: string }
  | { kind: "gone" }
  | { kind: "unchanged" };

export function readPickOutcome(
  ruleId: string,
  before: SettingsResponse,
  after: SettingsResponse,
): PickOutcome {
  const next = after.proactiveRules.find((rule) => rule.id === ruleId);
  if (next?.trigger !== "element_visible") return { kind: "gone" };
  const prev = before.proactiveRules.find((rule) => rule.id === ruleId);
  if (prev === undefined || next.selector !== prev.selector) {
    return { kind: "applied", selector: next.selector };
  }
  return { kind: "unchanged" };
}
